import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "residents-details mt-3" }
const _hoisted_2 = { class: "residents-details__tabs mt-3" }
const _hoisted_3 = { class: "p-tabview-title" }
const _hoisted_4 = { class: "p-tabview-title" }
const _hoisted_5 = { class: "p-tabview-title" }
const _hoisted_6 = { class: "p-tabview-title" }
const _hoisted_7 = { class: "d-flex align-items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ContactSection = _resolveComponent("ContactSection")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_GateAccessSection = _resolveComponent("GateAccessSection")
  const _component_BadgesSection = _resolveComponent("BadgesSection")
  const _component_CodeSection = _resolveComponent("CodeSection")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h4", null, _toDisplayString(_ctx.apartmentSelected.name), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.ContactTab")), 1),
              (_ctx.contactEdited || _ctx.errorContact)
                ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                    key: 0,
                    class: { 'has-error': _ctx.errorContact },
                    src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                    "aria-label": "tab-edited"
                  }, null, 8, ["class", "src"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ContactSection, {
                key: _ctx.updateApartKey,
                editingApartment: _ctx.editedApartment,
                onOnAddEditLabel: _ctx.onAddEditLabel,
                onOnDeleteLabel: _ctx.onDeleteLabel,
                onUpdateList: _ctx.handleUpdateList,
                onContactEdited: _ctx.handleContactEdited,
                onErrorContact: _ctx.handleErrorContact
              }, null, 8, ["editingApartment", "onOnAddEditLabel", "onOnDeleteLabel", "onUpdateList", "onContactEdited", "onErrorContact"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.GateAccessTab")), 1),
              (_ctx.gateAccessEdited || _ctx.errorGateAccess)
                ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                    key: 0,
                    class: { 'has-error': _ctx.errorGateAccess },
                    src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                    "aria-label": "tab-edited"
                  }, null, 8, ["class", "src"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_GateAccessSection, {
                key: _ctx.updateApartKey,
                editingApartment: _ctx.editedApartment,
                onGateAccessEdited: _ctx.handleGateAccessEdited,
                onErrorGateAccess: _ctx.handleErrorGateAccess
              }, null, 8, ["editingApartment", "onGateAccessEdited", "onErrorGateAccess"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.BadgeTab")), 1),
              (_ctx.badgeEdited || _ctx.errorBadge)
                ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                    key: 0,
                    class: { 'has-error': _ctx.errorBadge },
                    src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                    "aria-label": "tab-edited"
                  }, null, 8, ["class", "src"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_BadgesSection, {
                key: _ctx.updateApartKey,
                editingApartment: _ctx.editedApartment,
                onBadgeEdited: _ctx.handleBadgeEdited,
                onErrorBadge: _ctx.handleErrorBadge
              }, null, 8, ["editingApartment", "onBadgeEdited", "onErrorBadge"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.CodeTab")), 1),
              (_ctx.keyCodeEdited || _ctx.errorKeyCode)
                ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                    key: 0,
                    class: ["ml-auto", { 'has-error': _ctx.errorKeyCode }],
                    src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                    "aria-label": "tab-edited"
                  }, null, 8, ["class", "src"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CodeSection, {
                key: _ctx.updateApartKey,
                updateApartKey: _ctx.updateApartKey,
                editingApartment: _ctx.editedApartment,
                onKeyCodeEdited: _ctx.handleKeyCodeEdited,
                onErrorKeyCode: _ctx.handleErrorKeyCode
              }, null, 8, ["updateApartKey", "editingApartment", "onKeyCodeEdited", "onErrorKeyCode"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        class: "ml-auto p-button-rounded p-button-raised p-button--m",
        onClick: _ctx.onSaveClick,
        disabled: _ctx.saveDisabled
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("SaveChanges")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}